import { IonToast } from '@ionic/react';
import { useToast } from '../hooks/useToast';

export function ToastProvider() {
  const { message, color, isOpen, hideToast } = useToast();

  return (
    <IonToast
      isOpen={isOpen}
      message={message}
      color={color}
      duration={3000}
      position="bottom"
      onDidDismiss={hideToast}
    />
  );
}
